import { tv } from 'tailwind-variants';

export const hoverCardStyles = tv({
  slots: {
    content:
      'data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 rounded-[6px] bg-popover p-3 outline-none',
    trigger: 'aria-disabled:cursor-default cursor-pointer',
  },
  variants: {
    design: {
      default: {
        content: '',
        trigger: '',
      },
      email: {
        content:
          'max-h-96 rounded-xl max-w-lg overflow-y-auto text-sm leading-relaxed whitespace-pre-wrap text-popover-foreground border border-border shadow-md p-8',
        trigger: 'max-w-full',
      },
      note: {
        content:
          'max-h-96 min-w-2xs rounded-lg max-w-lg overflow-y-auto text-sm whitespace-pre-wrap text-popover-foreground border border-border shadow-md p-6',
        trigger: '',
      },
      survey: {
        content:
          'max-h-96 min-w-sm rounded-lg max-w-2xl grid grid-cols-2 gap-x-6 gap-y-3 overflow-y-auto text-sm leading-relaxed whitespace-pre-wrap text-popover-foreground border border-border shadow-sm p-6 pb-7',
        trigger: '',
      },
    },
  },
  defaultVariants: {
    design: 'default',
  },
});
